import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

import styled from './styled';
import './GroupComponent.scss';

class EditGroupComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channelId: 0,
      name: '',
      groupDescription: '',
      isCreating: false,
    };

    this._isMounted = false;

  }

  componentDidMount() {
    const { active, } = this.props;
    this._isMounted = true;

    if (active) {
      const id = active && active.subscriptions ? active.subscriptions.channel.id : 0;
      const channelName = active && active.subscriptions ? active.subscriptions.channel.channel_name : '';
      const desc = active && active.subscriptions ? active.subscriptions.channel.description : '';
      this.setState({ channelId: id, name: channelName, groupDescription: desc });
    }

  }

  componentDidUpdate(prevProps, prevState) {
    const { active, } = this.props;

    if (prevProps.active !== active) {
      if (active) {
        const channleId = active && active.subscriptions ? active.subscriptions.channel.id : 0;
        const channelName = active && active.subscriptions ? active.subscriptions.channel.channel_name : '';
        const desc = active && active.subscriptions ? active.subscriptions.channel.description : '';
        this.setState({ channelId: id, name: channelName, groupDescription: desc });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleNameChanged = (event) => {

    this.setState({ name: event.target.value });
  }

  handleDescriptionChanged = (event) => {

    this.setState({ groupDescription: event.target.value });
  }

  handleCancel = (event) => {
    const { notifyCancel, } = this.props;
    notifyCancel();
  }

  handleConfirm = (event) => {
    const { acitve, notifySaveChanges, } = this.props;
    const { channelId, name, groupDescription, } = this.state;

    if (!name.trim() || !groupDescription.trim()) return;

    this.setState({ isCreating: true });

    notifySaveChanges(channelId, name, groupDescription);
  }

  render() {
    const { name, groupDescription, isCreating } = this.state;

    const isDisabled = !name.trim() || !groupDescription.trim() || isCreating;

    const cancel = (<FormattedMessage
      id="EditGroupComponent.cancel"
      defaultMessage="Cancel"
    />);
    const confirm = (<FormattedMessage
      id="EditGroupComponent.confirm"
      defaultMessage="Confirm"
    />);
    const save = (<FormattedMessage
      id="EditGroupComponent.save"
      defaultMessage="Save Changes"
    />);
    const groupDetails = (<FormattedMessage
      id="EditGroupComponent.groupDetails"
      defaultMessage="Edit Group Details"
    />);
    const info = (<FormattedMessage
      id="EditGroupComponent.info"
      defaultMessage="Name your group and add a helpful description"
    />);
    const groupName = (<FormattedMessage
      id="EditGroupComponent.groupName"
      defaultMessage="Group Name"
    />);

    const description = (<FormattedMessage
      id="EditGroupComponent.description"
      defaultMessage="Enter Group Details"
    />);

    return (
      <div className="chat-modal-overlay">
        <div className="chat-modal-content">
          <div className="chat-modal-header">
            <h3 className="chat-modal-title">{groupDetails}</h3>
          </div>
          <div style={{ margin: '0 -24px' }}>
            <hr className="modal-divider-full" />
          </div>

          <label className="chat-modal-label">{groupName}</label>
          <input
            type="text"
            value={name}
            onChange={this.handleNameChanged}
            className="chat-modal-input"
            placeholder="Enter group name"
          />

          <label className="chat-modal-label">Group Description</label>
          <textarea
            value={groupDescription}
            onChange={this.handleDescriptionChanged}
            rows={4}
            className="chat-modal-textarea"
            placeholder="Enter group description"
          />

          <div className="chat-modal-actions">
            <button onClick={this.handleCancel} className="chat-modal-button cancel-button">{cancel}</button>
            <button onClick={this.handleConfirm} className="chat-modal-button primary-button" disabled={isDisabled}>
              {isCreating ? 'Updating...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

EditGroupComponent.propTypes = {
  //pins: PropTypes.arrayOf(PropTypes.object),
};

export default injectIntl(EditGroupComponent);